import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import AccountBalanceOutlinedIcon from "@material-ui/icons/AccountBalanceOutlined";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import SendOutlinedIcon from "@material-ui/icons/SendOutlined";
import MailOutlineOutlinedIcon from "@material-ui/icons/MailOutlineOutlined";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import NotificationsNoneOutlinedIcon from "@material-ui/icons/NotificationsNoneOutlined";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import PhoneOutlinedIcon from "@material-ui/icons/PhoneOutlined";
import FacebookIcon from "@material-ui/icons/Facebook";
import PinDropOutlinedIcon from "@material-ui/icons/PinDropOutlined";
import BusinessOutlinedIcon from "@material-ui/icons/BusinessOutlined";
import LocationCityOutlinedIcon from "@material-ui/icons/LocationCityOutlined";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import SupervisorAccountOutlinedIcon from "@material-ui/icons/SupervisorAccountOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import SearchIcon from "@material-ui/icons/Search";
import GetAppIcon from "@material-ui/icons/GetApp";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import AddIconMui from "@material-ui/icons/Add";
import TextFieldsIcon from "@material-ui/icons/TextFields";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import PostAddOutlinedIcon from "@material-ui/icons/PostAddOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import AttachFileIcon from "@material-ui/icons/AttachFile";
import SendIcon from "@material-ui/icons/Send";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import CheckIcon from "@material-ui/icons/Check";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BackupOutlinedIcon from "@material-ui/icons/BackupOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import TouchAppOutlinedIcon from "@material-ui/icons/TouchAppOutlined";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import PersonAddOutlinedIcon from "@material-ui/icons/PersonAddOutlined";
import CodeIcon from "@material-ui/icons/Code";
import ShareOutlinedIcon from "@material-ui/icons/ShareOutlined";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";

import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";

import { Image, CancelRounded } from "@material-ui/icons";

export const Attach = AttachFileIcon;
export const Send = SendIcon;
export const BackArrow = ArrowBackIosIcon;
export const Check = CheckIcon;
export const CheckCircle = CheckCircleIcon;
export const Add = AddCircleOutlineIcon;
export const AddIcon = AddIconMui;

const icons = {
  menu: <MenuIcon />,
  right: <ChevronLeftIcon />,
  settings: <SettingsOutlinedIcon />,
  payment: <AccountBalanceOutlinedIcon />,
  profile: <PersonOutlineOutlinedIcon />,
  invite: <SendOutlinedIcon />,
  messages: <MailOutlineOutlinedIcon />,
  dashboard: <DashboardOutlinedIcon />,
  logout: <ExitToAppIcon />,
  notification: <NotificationsNoneOutlinedIcon />,
  password: <LockOutlinedIcon />,
  email: <EmailOutlinedIcon />,
  person: <AccountCircleOutlinedIcon />,
  date: <CalendarTodayOutlinedIcon />,
  phone: <PhoneOutlinedIcon />,
  facebook: <FacebookIcon />,
  street: <PinDropOutlinedIcon />,
  apt: <BusinessOutlinedIcon />,
  state: <MyLocationIcon />,
  city: <LocationCityOutlinedIcon />,
  zip: <CreditCardIcon />,
  relation: <SupervisorAccountOutlinedIcon />,
  eye: <VisibilityOutlinedIcon />,
  search: <SearchIcon />,
  download: <GetAppIcon />,
  ticket: <ReceiptOutlinedIcon />,
  submit: <BackupOutlinedIcon />,
  group: <PeopleAltOutlinedIcon />,
  requests: <DescriptionOutlinedIcon />,
  trigger: <TouchAppOutlinedIcon />,
  save: <SaveOutlinedIcon />,
  memberSettings: <PersonAddOutlinedIcon />,
  blogs: <LibraryBooksIcon />,
  add: <AddIconMui />,
  text: <TextFieldsIcon />,
  send: <SendIcon />,
  copy: <CodeIcon />,
  share: <ShareOutlinedIcon />,
  arrowRight: <ArrowForwardIosIcon />,
  dollar: <MonetizationOnOutlinedIcon />,
  uploadDocs: <PostAddOutlinedIcon />,
  edit: <EditOutlinedIcon />,
  delete: <DeleteForeverOutlinedIcon />,
  image: <Image />,
  cancel: <CancelRounded />,
};

export default icons;
